var React = require('react');

function IconMobileMenuInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#000","fillRule":"evenodd"},React.createElement("path",{"d":"M.787.967h30v1h-30zM.787 11.967h30v1h-30z"})));
}

IconMobileMenuInline.defaultProps = {"width":"31","height":"13","viewBox":"0 0 31 13"};

module.exports = IconMobileMenuInline;

IconMobileMenuInline.default = IconMobileMenuInline;
